import Swiper from "swiper";
import { A11y, Autoplay, EffectFade } from "swiper/modules";

document.querySelectorAll(".element-testimonials").forEach((el) => {
  const container = el.querySelector(".swiper");
  const numSlides = el.querySelectorAll(".swiper-slide").length;

  if (numSlides > 1) {
    new Swiper(container, {
      modules: [A11y, Autoplay, EffectFade],
      slidesPerView: 1,
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: true,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      speed: 1000,
    });
  }
});
